import { Injectable } from '@angular/core';
import {Http, Headers} from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class MercadoriasService extends Service{

  protected url: string = this.dominio+"/adm/mercadorias/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  apagarFoto(id){
    let headers = this.getHeaderLogado();

    return this.http.delete(this.url + id+'/delete-foto', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  getIndicesClassificacao(id, relacionamentos = null, filtros = null){
    let headers = this.getHeaderLogado();

    let urlRelacionamentos = '';
    let urlFiltros = '';

    if(relacionamentos){
      urlRelacionamentos = 'relations='+JSON.stringify(relacionamentos)+'&';
    }

    if(filtros){
      urlFiltros = 'filters='+JSON.stringify(filtros)+'&';
    }

    return this.http.get(this.url + 'indices-classificacao/' + id + '/?'+ urlRelacionamentos + urlFiltros, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  duplicar(id) {
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id + '/duplicar', {}, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias/mercadorias.service.ts